<template>
  <v-card
    v-if="file"
    :href="file.url"
    target="_blank"
    :link="false"
    outlined
    :title="file.filename"
  >
    <v-list-item dense>
      <v-list-item-icon v-if="!imageMode" class="mr-3">
        <v-icon color="red darken-3" class="pt-3">mdi-file</v-icon>
      </v-list-item-icon>
      <v-list-item-avatar
        rounded
        size="60"
        style="border: 1px solid #ccc"
        v-else
      >
        <v-img :src="file.url"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ file.filename }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          @click.prevent.stop="handleClickDelete()"
          class="ml-1"
          icon
          small
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-card>
  <v-card v-else outlined>
    <v-list-item>
      <v-list-item-avatar>
        <v-progress-circular
          indeterminate
          color="primary"
          size="27"
        ></v-progress-circular>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title> A enviar... </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    file: Object,
    imageMode: Boolean,
  },

  data() {
    return {};
  },

  methods: {
    handleClickDelete() {
      this.$emit("click:remove");
    },
  },

  computed: {},
};
</script>
